// main #C97E8D

export const japanPrimaryColor = "#C97E8D" // contrast of 3 with white
export const japanPrimaryColorDarker = "#ba5b6e" // 15% darker
export const japanCherryBlossom = "#f0bed6"
